<div class="study-gantt-chart-container">
  <div class="study-gantt-chart-title">
    Milestone viewer
    <study-gantt-chart-legend></study-gantt-chart-legend>
  </div>
  <ng-container *ngIf="!showErrorBlock; else errorBlock">
    <smart-gantt-chart
      #ganttchart
      *ngIf="dataLoaded"
      [dataSource]="dataSource"
      [taskColumns]="taskColumns"
      [columnResize]="false"
      [currentTimeIndicator]="currentTimeIndicator"
      [disableTaskDrag]="true"
      [disableTaskProgressChange]="true"
      [disableTaskResize]="true"
      [disableSelection]="true"
      [disableWindowEditor]="true"
      [disableSegmentDrag]="true"
      [disableSegmentResize]="true"
      [tooltip]="tooltip"
      [treeMin]="taskTreeMinDefaultSize"
      [treeSize]="taskTreeMinDefaultSize"
      (onConnectionStart)="disableElementConnections($event)"
      (onOpening)="disableConnectionTooltip($event)"
      (onExpand)="handleStageToggle($event)"
      (onCollapse)="handleStageToggle($event)"
    ></smart-gantt-chart>
  </ng-container>
  <ng-template #errorBlock>
    <error-view type="milestone-viewer" class="study-gantt-chart-error-block"></error-view>
  </ng-template>
</div>
